import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  getPropagationsFailure,
  getPropagationsSuccess,
  postDeletePropagationsFailure,
  postDeletePropagationsSuccess,
  postUpdatePropagationsFailure,
  postUpdatePropagationsSuccess,
} from "./actions";
import {
  fetchPropagations,
  postDeletePropagation,
  postUpdatePropagation,
} from "./services";

const fetchPropagationsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_PROPAGATIONS),
    mergeMap(() =>
      fetchPropagations().pipe(
        map((response: any) => getPropagationsSuccess(response)),
        catchError((error: any) => of(getPropagationsFailure(error)))
      )
    )
  );

const postUpdatePropagationEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_UPDATE),
    mergeMap((action: any) =>
      postUpdatePropagation(action.payload).pipe(
        map((response: any) => postUpdatePropagationsSuccess(response)),
        catchError((error: any) => of(postUpdatePropagationsFailure(error)))
      )
    )
  );

const postDeleteEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_DELETE),
    mergeMap((action: any) =>
      postDeletePropagation(action.payload).pipe(
        map((response: any) => postDeletePropagationsSuccess(response)),
        catchError((error: any) => of(postDeletePropagationsFailure(error)))
      )
    )
  );

export default [
  fetchPropagationsEpic,
  postUpdatePropagationEpic,
  postDeleteEpic,
];
